'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (formConfig, formValues, trackingCode, coverageType) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  additional_data.coverage_type = (0, _url2.default)('coverage');
  additional_data.group_number = 1;

  return _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: expiry_date
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/international-students/application.js
// module id = 1727
// module chunks = 0